import React, { useState } from 'react';
import { Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { EvaluationStatusDialog } from './EvaluationStatusDialog';

export const EvaluationStatusButton = (
  {
    rateable,
    raterDone,
    isEvaluationClosed,
    isCurrentUser,
    objective,
    appraiserId,
    onSubmitSuccess
  }
) => {
  const [ evaluationStatusDialogOpen, setEvaluationStatusDialogOpen ] = useState(false);

  const { t } = useTranslation();

  const useStyles = makeStyles({
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: '521px',
      marginBottom: '15px'
    }
  });

  const classes = useStyles();
  return (
    isCurrentUser && <>
      <Grid className = { classes.container } container direction = { 'row' }>
        <Button
          onClick = {
            () => setEvaluationStatusDialogOpen(true)
          }
          disabled = { !rateable || !raterDone }
          variant="contained"
          color="primary"
        >
          {t('objective.evaluation.status.lock.button')}
        </Button>
      </Grid>
      <EvaluationStatusDialog
        objective = { objective }
        evaluationStatusDialogOpen = { evaluationStatusDialogOpen }
        setEvaluationStatusDialogOpen = { setEvaluationStatusDialogOpen }
        isEvaluationClosed={ isEvaluationClosed }
        appraiserId={ appraiserId }
        onSubmitSuccess={ onSubmitSuccess }
      />
    </>
  );
};